import { useCallback, useState } from "react";
import { createContainer, useContainer } from "unstated-next";

import {
  EHR_API_ENDPOINT,
  EHR_API_QUEUE_PATH,
} from "../../environments/environment";

import { ApolloEndpointProviderContextData } from "./ApolloEndpointProvider.types";
import { getValidatedEndpoint } from "./endpoint-helper";

function useApolloEndpointHook(): ApolloEndpointProviderContextData {
  const [endpoint, setEndpointInner] = useState(
    getValidatedEndpoint(EHR_API_ENDPOINT)
  );

  const [ehrQueueEndpoint, setEhrQueueEndpointInner] = useState(
    getValidatedEndpoint(EHR_API_ENDPOINT, EHR_API_QUEUE_PATH)
  );

  const [isEndpointUpdated, setIsEndpointUpdated] = useState(false);

  const setEndpoint = useCallback((newEndpoint: string) => {
    setEndpointInner(getValidatedEndpoint(newEndpoint));
    setEhrQueueEndpointInner(
      getValidatedEndpoint(newEndpoint, EHR_API_QUEUE_PATH)
    );
    setIsEndpointUpdated(true);
  }, []);

  return {
    endpoint,
    ehrQueueEndpoint,
    setEndpoint,
    isEndpointUpdated,
  };
}

const ApolloEndpointProviderContext = createContainer(useApolloEndpointHook);

export const ApolloEndpointProvider = ApolloEndpointProviderContext.Provider;

export const useEndpoint = (): ApolloEndpointProviderContextData =>
  useContainer(ApolloEndpointProviderContext);
